<!-- <div> -->
  <div class="donut-graph"
    [ngClass]="{'donut-graph--center': configurateReport.type === 1 && configurateReport.subType === 2,
      'donut-graph--poll': configurateReport.type === 'poll',
      'donut-graph--be':configurateReport.type ==='be'}">
      <div class="donut-graph__graph"
        [ngClass]="{'donut-graph__graph--residual': configurateReport.type === 'poll' || configurateReport.type === 'be' || configurateReport.type === 'risk'}"
        [id]="idGraph"></div>
      <div class="line-graph__tooltip-box line-graph__tooltip-box--donut"
        [id]="'donut-graph-tooltip-'+idGraph"
        *ngIf=" configurateReport.type==='risk'">
        <div class="donut-graph__tooltip-block">
          <div class="donut-graph__tooltip-header-container">
            <div class="donut-graph__tooltip-header-text-block">
              <div class="donut-graph__icon-container">
                <i class="lf-icon-step-final"
                  [ngStyle]="{'color':donutGraph.selectInfoTooltip.color}"></i>
              </div>
              <p class="donut-graph__tooltip-header-text">
                <span>{{donutGraph.selectInfoTooltip?.label}}</span>
                <span>{{donutGraph.selectInfoTooltipPercent}}</span>
              </p>
            </div>
            <div class="donut-graph__icon-container donut-graph__icon-container--with-hover">
              <i class="lf-icon-close"
                (click)="closeRiskTooltip('')"></i>
            </div>
          </div>
          <div class="donut-graph__tooltip-body-container">
            <ul class="donut-graph__tooltip-body-list">
              <li *ngFor="let risk of donutGraph.selectInfoTooltipRiskList"
                class="donut-graph__tooltip-body-item">
                {{risk}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="donut-graph__tooltip-donut"
        [id]="'donut-graph-tooltip-'+idGraph"
        *ngIf="configurateReport.type === 'poll' || configurateReport.type === 'be'">
        <p class="donut-graph__inner-tooltip-donut"
          [id]="'donut-graph-tooltip-text-'+idGraph"></p>
      </div>
      <button [ngShow]="from==='resultReports'" #tooltip="matTooltip"
        class="horizontal-poll-graph__capture"
        (click)="saveAsPng(tooltip)"
        [disabled]="donutGraph.disabledSaveAsPng"
        [matTooltipDisabled]="donutGraph.disableTooltip"
        [matTooltip]="'results-report.capture-image' | afTranslate" matTooltipPosition="above"
        matTooltipPosition="above"
        matTooltipClass="above">
        <i class="lf-icon-all"></i>
      </button>
      <div class="donut-graph__block-list-legend"
          [ngShow]="configurateReport.type === 1 && configurateReport.subType === 2">
          <ul class="donut-graph__list-legend">
              <li *ngFor="let legend of donutGraph.graphData?.original"
                class="donut-graph__element-list-legend"
                [ngStyle]="{'color': legend.color}">
                  <span class="donut-graph__text-element-legend">{{legend.dataX}}</span>
              </li>
          </ul>
      </div>
    </div>
